import { defineStore } from 'pinia';

export const useTokenStore = defineStore('token', {
    state: () => {
        return {
            token: '',
            userid: '',
            username: '',
            icon: '',
            userInfo: null,
            isBizManager: false,
            tag: null,
            scope:'',
            isDepartmentHead:false,
            isLogin:false,
            nickname:''
        }
    },
    actions: {
        setToken(token) {
            this.token = token;
        },
        setUserInfo(userInfo) {
            this.userInfo = userInfo;
            if (userInfo) {
                this.token = userInfo.token;
                this.username = userInfo.userName;
                this.nickname = userInfo.nickName;
                this.userid = userInfo.userId;
                this.isBizManager = userInfo.priviledgeScope == '3' && userInfo.priviledgeType == '2';
                this.scope = userInfo.scope;
                this.isLogin = true
                const roles = userInfo.roles;
                if(userInfo.userDept&&userInfo.userDept.length>0){
                  for (const data of userInfo.userDept) {
                     if(data.isDepartmentHead&&data.isDepartmentHead=='yes'){
                        this.isDepartmentHead = true
                        break
                     }
                  }
                }
                if (roles) {
                    for (const role of roles) {
                        if (role.remark) {
                            this.tag = role.remark; 
                            break;
                        }
                    }
                } else {
                    this.tag = null;
                }
            } else {
                this.token = '';
                this.userid = '';
                this.username = '';
                this.isBizManager = false;
                this.tag = null;
            }
        },
        setTag(tag) {
            this.tag = tag;
        }
    }
})